import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCYF448RXYSF06Xul6yxmcaO3h2vmKmewc",
  authDomain: "bodework-1695f.firebaseapp.com",
  databaseURL: "https://bodework-1695f.firebaseio.com",
  projectId: "bodework-1695f",
  storageBucket: "bodework-1695f.appspot.com",
  messagingSenderId: "919206110205",
  appId: "1:919206110205:web:5fd4e58f9639903a492f94",
  measurementId: "G-FP9YM3JV2Y",
});


const DB = firebaseApp;

export default DB;
